import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ShareAnalyticsButton } from './ShareAnalyticsButton';

export interface AnalyticsHeaderProps {
  selectedCampaign: string;
  onSelectCampaign: (campaignId: string) => void;
  campaigns: Array<{ id: string; name: string }>;
  campaignsLoading: boolean;
  selectedCampaignName: string;
}

export const AnalyticsHeader: React.FC<AnalyticsHeaderProps> = ({
  selectedCampaign,
  onSelectCampaign,
  campaigns,
  campaignsLoading,
  selectedCampaignName,
}) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Analytics & Reports</h1>
        <p className="text-gray-600">
          Track campaign performance and ROI across all your campaigns
          {selectedCampaign && selectedCampaignName && (
            <span className="ml-2 text-sm bg-purple-100 text-purple-700 px-2 py-1 rounded">
              {selectedCampaignName}
            </span>
          )}
        </p>
      </div>
      <div className="flex space-x-3">
        <Select value={selectedCampaign} onValueChange={onSelectCampaign}>
          <SelectTrigger className="w-[200px] border-2">
            <SelectValue placeholder="Select Campaign" />
          </SelectTrigger>
          <SelectContent>
            {campaignsLoading ? (
              <SelectItem value="loading" disabled>
                Loading campaigns...
              </SelectItem>
            ) : (
              campaigns.map((campaign) => (
                <SelectItem key={campaign.id} value={campaign.id}>
                  {campaign.name}
                </SelectItem>
              ))
            )}
          </SelectContent>
        </Select>
        {selectedCampaign && <ShareAnalyticsButton campaignId={selectedCampaign} />}
      </div>
    </div>
  );
};

export default AnalyticsHeader;
